import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';

export class PasswordRecoverController implements ng.IController {

    static $inject: string[] = [
        '$state',
        '$stateParams',
        '$scope',
        'store',
        'ArchiSmallServices',
        '$rootScope'
    ];

    constructor(
        private $state: ng.ui.IStateService,
        private $stateParams: any,
        private $scope: any,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices,
        private $rootScope: any,
    ) {
        // state 0 - page loaded, wait for token validation
        // state 1 - token valid, ask secret answer
        // state 2 - token valid, secret answered, change pwd
        // state 3 - operation status

        $scope.tooltips = {
            'password': 'Scegli la tua password, di almeno 8 caratteri alfanumerici, che userai per accedere ad ArchiSMALL. Ti consigliamo di utilizzare lettere maiuscole, minuscole e numeri.',
            'passwordConfirmation': 'Inserisci di nuovo la password. Deve combaciare con la password già inserita.'
        };
        $scope.passwordType = new RegExp('^.{8,}$');
        $scope.state = 0;
        $scope.questionId = '';
        $scope.answer = '';
        $scope.error = '';
        let attempts = 0;
        $scope.answerToSecretQuestion = function () {
            attempts++;
            ArchiSmallServices.recoverPassword({ settings: { option: 2, token: $stateParams.token, answer: $scope.answer } })
                .then((response: any) => {
                    if (response.state === 1) {
                        $scope.error = '';
                        $scope.state = 2;
                    } else {
                        if (attempts <= 5) {
                            $scope.answer = '';
                            $scope.error = 'Risposta errata! prova ancora...';
                        } else {
                            $scope.state = 3;
                            $scope.changePasswordResult = 0;
                        }
                    }
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        $scope.validPassword = true;
        $scope.validatePasswords = (password, passwordConfirmation) => {
            if (password === passwordConfirmation) {
                $scope.validPassword = true;
            } else if (password !== undefined && passwordConfirmation !== undefined) {
                $scope.validPassword = false;
            }
        };
        $rootScope.formsubmitted = false;
        $scope.changePasswordResult = 0;
        $scope.changePassword = () => {
            ArchiSmallServices.recoverPassword({ settings: { option: 3, token: $stateParams.token, answer: $scope.answer, password: $scope.newPassword } })
                .then((response: any) => {
                    if (response.state === 1) {
                        $scope.state = 3;
                        $scope.changePasswordResult = 1;
                    } else {
                        $scope.state = 3;
                        $scope.changePasswordResult = 0;
                    }
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        $scope.cancel = () => {
            $state.go('login');
        };
        $scope.questions = {
            '1': 'Qual è la tua squadra del cuore?',
            '2': 'Qual è il nome del tuo cane?',
            '3': 'Qual è il nome del tuo gatto?',
            '4': 'Qual è la tua serie TV preferita?',
            '5': 'Gruppo musicale preferito?',
            '6': 'Qual è il cognome da nubile di tua madre/nonna?',
            '7': 'Qual è il nome della tua bisnonna?',
            '8': 'Qual è il nome del/della tua maestra/o o della scuola?',
            '9': 'Qual è il nome del tuo primo animale domestico?',
            '10': 'Qual è il tuo cibo preferito?',
            '11': 'Quale film non ti stancheresti mai di vedere?',
            '12': 'Qual è il tuo libro preferito?',
            '13': 'Qual è il nome del tuo eroe da bambino?'
        };

        ArchiSmallServices.recoverPassword({ settings: { option: 1, token: $stateParams.token } })
            .then((response: any) => {
                if (response.state === 1) {
                    $scope.questionId = response.question;
                    $scope.customQuestionLabel = response.custom_question_label;
                    $scope.state = 1;
                } else {
                    $scope.state = 3;
                    $scope.changePasswordResult = 0;
                }
            }, (error) => {
                $rootScope.alert('error', error);
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/password-recover/password-recover.controller.ts